/**
 * Цвет статуса — ОДНА таблица на всё приложение.
 *
 * ЗАЧЕМ ЭТОТ МОДУЛЬ. Один и тот же смысл («норма» / «следим» / «тревога»)
 * красился в трёх местах тремя разными путями:
 *
 *  - лента «СОБЫТИЯ» на Today (`EventsFeed`) держала свой словарь и брала
 *    СЫРЫЕ ступени шкал: `var(--warning-500)`, `var(--danger-500)`;
 *  - карточка «Перегрузка» (`TrainingLoadCard` в AnalyticsPage) красила
 *    МОНОТОННОСТЬ/ACWR/ПРИРОСТ CTL своими ветками через темо-алиасы
 *    `var(--warn)` / классы `text-warn`;
 *  - статусные подписи тайлов (`StatTile.subTone`) — третьей копией той же
 *    таблицы в тернарнике классов text-ok / text-warn / text-bad.
 *
 * Пока копии совпадают — это невидимый дубль; расходятся они молча.
 * Пример уже случился: `var(--warning-500)` и `var(--warn)` в тёмной теме —
 * один цвет (#E8A547), а в светлой уже нет: светлая тема затемнила СВОЙ
 * алиас ради контраста на кремовом (index.css:373-382), и сырой токен
 * этот фикс обошёл. Слово и цвет статуса обязаны спрашивать одну таблицу —
 * вот её место. Компоненты выбирают ТОН, таблица выдаёт цвет.
 *
 * ДВЕ КОЛОНКИ, потому что роль «текст» отделена от роли «заливка»
 * (tailwind.config.js:173-192): text-bad берёт текстовую ступень шкалы
 * (--bad-text, выверенную на карточке до AA), а точки и штрихи — заливочную
 * --bad. Инлайновый STATUS_TONE_COLOR на текстовой подписи был бы
 * визуальным изменением — для текста есть STATUS_TONE_TEXT_CLASS.
 *
 * Модуль чистый и без React.
 */

export type StatusTone = "ok" | "watch" | "warn" | "bad" | "muted";

/**
 * Цвет-заливка тона: точки событий, штрихи спарклайнов, бейджи.
 * watch («следим») и warn («повышена») сегодня делят амбер — это осознанно:
 * различает их слово, а не оттенок.
 */
export const STATUS_TONE_COLOR: Record<StatusTone, string> = {
  ok: "var(--ok)",
  watch: "var(--warn)",
  warn: "var(--warn)",
  bad: "var(--bad)",
  muted: "var(--fg-muted)",
};

/**
 * Класс для ТЕКСТОВОЙ подписи того же тона. Классы полные литералы —
 * Tailwind собирает по вхождению строки в исходник, шаблонные куски
 * классов не эмитятся.
 */
export const STATUS_TONE_TEXT_CLASS: Record<StatusTone, string> = {
  ok: "text-ok",
  watch: "text-warn",
  warn: "text-warn",
  bad: "text-bad",
  muted: "text-fg-muted",
};
